import {FlexiButton} from '@flexinet/ui-components';

import {useRestoreAccountMutation} from '../hooks/useAccountsQuery';
import {useAccountsSelection} from '../hooks/useAccountsSelection.ts';
import {AiOutlineUndo} from 'react-icons/ai';


// FNP-383: admin Restore button. Flips selected PENDING_DELETION accounts
// back to ACTIVE via the console-api restoreAccount 3-step pipeline (FNP-382)
// which emits the account-restoration-completed EventBridge event consumed
// by workflows-api (FNP-381) to re-enable the Cognito user.
//
// No confirmation modal here — restoration is the reversible direction
// (Cognito re-enable + status flip), unlike Remove which kicks off the
// 30-day cascade. If a confirmation step is wanted later, mirror the
// DeleteRecordButton + DeleteRecordsConfirmationButton pattern.
export const RestoreRecordButton = () => {

    const restoreAccountMutation = useRestoreAccountMutation();

    const {
        selection,
        handleClearSelection,
    } = useAccountsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleRestore = async () => {
        for (const id of recordIds) {
            await restoreAccountMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<FlexiButton
        leftSection={<AiOutlineUndo/>}
        disabled={disabled}
        onClick={handleRestore}
    >Restore</FlexiButton>);

};
